var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-snotify'),_c('div',{attrs:{"id":"full-page"}},[_c('div',{staticClass:"layout max-w-lg mx-auto bg-pttr-white"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }